module.exports = __webpack_public_path__ + "img/onboarding-shape-lg.c87d4686.svg";